/* globals angular, _ */
"use strict";

angular.module("mandaeApp").config(function($stateProvider) {
  $stateProvider
    // route to show our pedido (/historico)
    .state("historico", {
      url: "/historico?tour",
      redirectTo: "encomendas",
      template: require("./history.html"),
      controller: "HistoricoCtrl as vm",
      data: {
        headerMenuItems: [
          {
            icon: "packages:list",
            text: "ENCOMENDAS",
            state: "encomendas"
          },
          {
            icon: "packages:incident",
            text: "OCORRÊNCIAS",
            state: "packages-list"
          },
          {
            icon: "packages:reverse",
            text: "REVERSAS",
            state: "reverse-list"
          },
          {
            icon: "packages:return",
            text: "DEVOLUÇÕES",
            state: "devolucoes"
          }
          // {
          //   icon: "packages:report",
          //   text: "RELATÓRIOS",
          //   state: "relatorios"
          // }
        ]
      },
      resolve: {
        betaPermission: [
          "$state",
          "Perfil",
          function($state, Perfil) {
            return Perfil.getBetaFeatures().then(function(data) {
              if (data.error) {
                console.error(
                  "Beta Features API error:",
                  data.error,
                  data.message
                );
                return false;
              }
              var permissoes = data.funcionalidades;
              var ocorrenciaAcesso = _.find(permissoes, function(
                funcionalidade
              ) {
                return (
                  funcionalidade.codigo === "gerenciamento-ocorrencia" &&
                  funcionalidade.possuiAcesso
                );
              });
              var chartsAcesso = _.find(permissoes, function(funcionalidade) {
                return funcionalidade.codigo === "charts";
              });

              var permissions = {
                occurrences: ocorrenciaAcesso && ocorrenciaAcesso.possuiAcesso,
                charts: chartsAcesso && chartsAcesso.possuiAcesso
              };

              return permissions;
            });
          }
        ]
      }
    })
    // url will be app/historico/encomendas
    .state("encomendas", {
      parent: "historico",
      url: "/encomendas",
      component: "appEncomendaListagem"
    })
    .state("devolucoes", {
      parent: "historico",
      url: "/devolucoes",
      component: "appShippingReturnListing",
      data: {
        pageTitle: "Mandaê - Histórico de Devoluções"
      }
    })
    .state("relatorios", {
      parent: "historico",
      url: "/relatorios",
      component: "appRelatorioListagem"
    });
});
